import { Transition } from "@headlessui/react"
import { Form, Head, usePage } from "@inertiajs/react"

import DeleteUser from "@/components/delete-user"
import HeadingSmall from "@/components/heading-small"
import InputError from "@/components/input-error"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import AppLayout from "@/layouts/app-layout"
import SettingsLayout from "@/layouts/settings/layout"
import { settingsProfilePath } from "@/routes"
import type { BreadcrumbItem } from "@/types"

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: "Profile settings",
    href: settingsProfilePath(),
  },
]

export default function Profile() {
  const { auth } = usePage().props

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={breadcrumbs[breadcrumbs.length - 1].title} />

      <div className="p-6">
        <SettingsLayout>
          <div className="space-y-6">
            <HeadingSmall
              title="Profile information"
              description="Update your name"
            />

            <Form
              method="patch"
              action={settingsProfilePath()}
              options={{
                preserveScroll: true,
              }}
              className="space-y-6"
            >
              {({ errors, processing, recentlySuccessful }) => (
                <>
                  <div className="grid gap-2">
                    <Label htmlFor="name">Name</Label>

                    <Input
                      id="name"
                      name="name"
                      className="mt-1 block w-full"
                      defaultValue={auth.user.name}
                      required
                      autoComplete="name"
                      placeholder="Full name"
                    />

                    <InputError className="mt-2" messages={errors.name} />
                  </div>

                  <div className="flex items-center gap-4">
                    <Button disabled={processing}>Save</Button>

                    <Transition
                      show={recentlySuccessful}
                      enter="transition ease-in-out"
                      enterFrom="opacity-0"
                      leave="transition ease-in-out"
                      leaveTo="opacity-0"
                    >
                      <p className="text-sm text-neutral-600">Saved</p>
                    </Transition>
                  </div>
                </>
              )}
            </Form>
          </div>

          <DeleteUser />
        </SettingsLayout>
      </div>
    </AppLayout>
  )
}
